import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import LoginForm from '../components/LoginForm';
import { useAuthState } from '../core';
import { MIDDLE_STYLE } from '@constants/responsive';

type Props = {};

const AuthScreen = (props: Props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { user } = useAuthState();

  useEffect(() => {
    setIsAuthenticated(!!user);
  }, [user]);

  return isAuthenticated ? (
    <Redirect to={'/app'} />
  ) : (
    <div style={{ ...MIDDLE_STYLE, height: '100vh' }}>
      <LoginForm />
    </div>
  );
};

export default AuthScreen;
